import { render } from "./CanvasCard.vue?vue&type=template&id=2d6d05f6&scoped=true"
import script from "./CanvasCard.vue?vue&type=script&lang=js"
export * from "./CanvasCard.vue?vue&type=script&lang=js"

import "./CanvasCard.vue?vue&type=style&index=0&id=2d6d05f6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2d6d05f6"

export default script